import { render } from "./AdsetInfoEditor.vue?vue&type=template&id=28c6681c"
import script from "./AdsetInfoEditor.vue?vue&type=script&lang=js"
export * from "./AdsetInfoEditor.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__